import api from "./api";

// Signed upload to Cloudinary, then register in the media library.
export async function uploadToCloudinary(file, folder = "uploads") {
  const { data: sig } = await api.get(`/cloudinary/signature`, {
    params: { folder, resource_type: "image" },
  });

  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`,
    { method: "POST", body: form }
  );
  const result = await res.json();
  if (!result.secure_url) {
    throw new Error(result?.error?.message || "আপলোড ব্যর্থ হয়েছে");
  }

  try {
    await api.post("/admin/media", {
      url: result.secure_url,
      public_id: result.public_id,
      name: file.name,
      folder,
      resource_type: "image",
    });
  } catch (e) {
    /* media registration is best-effort */
  }

  return result.secure_url;
}
